declare global {
  interface Window {
    EnvConfig: any;
  }
}

const config = window.EnvConfig;

export default config;
